// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__16QBH","rootSmall":"AddTileButton_rootSmall__2XAvQ"};